import { CSSTransitionProps } from 'preact-transitioning';

import { TransitionTypeEnum } from './type.enum';

/**
 * Map the transition types to the props
 */
export const transitionMapTypeToProps = (type: TransitionTypeEnum) =>
  ((
    {
      [TransitionTypeEnum.slideUp]: {
        classNames: 'transition-slide-up',
        duration: 700,
        exit: true,
        appear: true,
      },
    } as Record<TransitionTypeEnum, CSSTransitionProps>
  )[type]);
